import Terms from 'components/Footer/Terms';
import StandalonePage from 'components/StandalonePage';
export default () => (
  <StandalonePage>
    <Terms />
  </StandalonePage>
);
